import React from 'react'

import { Show } from '@app/components/util'
import { isNullable } from '@app/utils'

import {
  TableSizeButton,
  TableGroupButton,
  TableSettingButton,
  TableSearchButton,
  TableRowHighlightButton
} from './components'

import styles from './styles.module.scss'

import type { TableSettingsToolbarProps } from './types'

export const TableSettingsToolbar: React.FC<TableSettingsToolbarProps> = ({
  children,
  tableGroupButtonProps,
  tableRowHighlightButtonProps,
  tableSizeButtonProps,
  tableSettingButtonProps,
  tableSearchButtonProps
}) => {
  return (
    <div className={ styles.tableSettingsToolbar }>
      { children }

      <Show condition={ !isNullable(tableGroupButtonProps) }>
        <TableGroupButton { ...tableGroupButtonProps } />
      </Show>

      <Show condition={ !isNullable(tableRowHighlightButtonProps) }>
        <TableRowHighlightButton { ...tableRowHighlightButtonProps } />
      </Show>

      <TableSizeButton { ...tableSizeButtonProps } />

      <TableSettingButton { ...tableSettingButtonProps } />

      <TableSearchButton { ...tableSearchButtonProps } />
    </div>
  )
}
